import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const ListingHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.5rem;
`;

export const ListingHeading = styled(Typography)``;
